<template>
    <v-container fluid>
        <v-layout align-center justify-center>
            <v-flex xs12 sm12 md12 lg10 xl10>                
                <!-- Row with select fields -->
                <v-layout 
                    align-center 
                    justify-space-between
                    pb-2 px-3
                    class="grey lighten-3 rounded-block"                    
                >
                    <v-flex xs12 sm6 md5 lg4 xl4 px-3 >
                        <v-layout row justify-space-around align-center>
                            <v-switch v-model="group_by_day"
                                color="success"
                                label="Group by day"
                                style="max-width: 170px"
                            ></v-switch>
                            <v-switch v-model="group_by_month"
                                color="success"
                                label="Group by month"
                                style="max-width: 170px"
                            ></v-switch>
                        </v-layout>
                        <v-layout row justify-center style="padding-top: 5px">
                            <v-flex xs5>
                                <!-- Date picker from -->
                                <v-menu
                                    v-model="date_from_menu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    full-width
                                    min-width="290px"
                                    offset-y
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="date_from"
                                            label="Date From"
                                            prepend-icon="event"
                                            readonly
                                            v-on="on"                                            
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker 
                                        v-model="date_from" 
                                        @input="date_from_menu = false"
                                        :max="date_to"
                                    ></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs0 md1></v-flex>
                            <v-flex xs5>
                                <!-- Date picker to -->
                                <v-menu
                                    v-model="date_to_menu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    full-width
                                    min-width="290px"
                                    offset-y                         
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="date_to"
                                            label="Date To"
                                            prepend-icon="event"
                                            readonly
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker 
                                        v-model="date_to" 
                                        @input="date_to_menu = false"
                                        :min="date_from"
                                        :max="date_today"
                                    ></v-date-picker>
                                </v-menu>
                            </v-flex>
                        </v-layout>
                    </v-flex>

                    <!-- Platfrom section -->
                    <v-flex xs12 sm6 md3 lg3 xl2 px-3>
                        <v-layout row justify-center>
                            <v-switch v-model="group_by_platform"
                                color="success"
                                label="Group by"
                                style="max-width: 120px"
                            ></v-switch>
                        </v-layout>
                        <v-select
                            v-model="selected_platforms"
                            :items="getPlatforms"
                            item-text="name"
                            item-value="external_id"
                            :menu-props="{maxHeight: '600', offsetY:true}"
                            label="Platform"
                            multiple
                            chips                            
                        >   
                            <!-- Adding Select/Unselect all row to dropdown -->
                            <v-list-tile
                                slot="prepend-item"
                                ripple
                                @click="selectAllPlatforms"
                                v-if="getPlatforms.length > 0"
                            >
                                <v-list-tile-title>{{select_all_platforms_label}}</v-list-tile-title>
                            </v-list-tile>
                            <v-divider
                                slot="prepend-item"
                                class="mt-2"
                            ></v-divider>
                        </v-select>
                    </v-flex>

                    <!-- Advertiser section -->
                    <v-flex xs12 sm6 md3 lg3 xl2 px-3>
                        <v-layout row justify-center>
                            <v-switch v-model="group_by_advertiser"
                                color="success"
                                label="Group by"
                                 style="max-width: 120px"
                            ></v-switch>
                        </v-layout>
                        <v-select
                            v-model="selected_advertisers"
                            :items="getAdvertisers"
                            item-text="name"
                            item-value="external_id"
                            :menu-props="{maxHeight: '600', offsetY:true}"
                            label="Advertiser"
                            multiple
                            chips
                        >
                            <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index === 0 || index === 1 || index === 2">
                                    <span>{{ item.name }}</span>
                                </v-chip>
                                <span
                                    v-if="index === 3"
                                    class="black--text body-1"
                                >(+{{ selected_advertisers.length - 3 }} more)</span>
                            </template>
                            <v-list-tile
                                slot="prepend-item"
                                ripple
                                @click="selectAllAdvertisers"
                                v-if="getAdvertisers.length > 0"
                            >
                                <v-list-tile-title>{{select_all_advertisers_label}}</v-list-tile-title>
                            </v-list-tile>
                            <v-divider
                                slot="prepend-item"
                                class="mt-2"
                            ></v-divider>
                        </v-select>
                    </v-flex>

                    <!-- Campaign section -->
                    <v-flex xs12 sm6 md3 lg3 xl2 px-3>
                        <v-layout row justify-center>
                            <v-switch v-model="group_by_campaign"
                                color="success"
                                label="Group by"
                                 style="max-width: 120px"
                            ></v-switch>
                        </v-layout>
                        <v-select
                            v-model="selected_campaigns"
                            :items="getCampaigns"
                            item-text="name"
                            item-value="external_id"
                            :menu-props="{maxHeight: '600', offsetY:true}"
                            label="Campaign"
                            multiple
                            chips
                        >
                            <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index === 0 || index === 1">
                                    <span>{{ item.name }}</span>
                                </v-chip>
                                <span
                                    v-if="index === 2"
                                    class="black--text body-1"
                                >(+{{ selected_campaigns.length - 2 }} more)</span>
                            </template>
                            <v-list-tile
                                slot="prepend-item"
                                ripple
                                @click="selectAllCampaigns"
                                v-if="getCampaigns.length > 0"
                            >
                                <v-list-tile-title>{{select_all_campaigns_label}}</v-list-tile-title>
                            </v-list-tile>
                            <v-divider
                                slot="prepend-item"
                                class="mt-2"
                            ></v-divider>
                        </v-select>
                    </v-flex>

                    <!-- OS section -->
                    <v-flex xs12 sm6 md3 lg3 xl2 px-3>
                        <v-layout row justify-center>
                            <v-switch v-model="group_by_os"
                                color="success"
                                label="Group by"
                                 style="max-width: 120px"
                            ></v-switch>
                        </v-layout>
                        <v-select
                            v-model="selected_os"
                            :items="os_choices"
                            item-text="name"
                            item-value="os_id"
                            :menu-props="{maxHeight: '600', offsetY:true}"
                            label="OS"
                            multiple
                            chips
                        >
                            <template v-slot:selection="{ item, index }">
                                <v-chip >
                                    <span>{{ item.name }}</span>
                                </v-chip>
                            </template>
                            <v-list-tile
                                slot="prepend-item"
                                ripple
                                @click="selectAllOS"
                                v-if="os_choices.length > 0"
                            >
                                <v-list-tile-title>{{select_all_os_label}}</v-list-tile-title>
                            </v-list-tile>
                            <v-divider
                                slot="prepend-item"
                                class="mt-2"
                            ></v-divider>
                        </v-select>
                    </v-flex>

                    <!-- Country section -->
                    <!-- <v-flex xs12 sm6 md4 lg3 xl2 px-3>
                        <v-card>Country</v-card>
                    </v-flex> -->

                    <!-- Run button -->
                    <v-flex xs2 sm2 md2 lg2 xl2 class="text-md-center">
                        <v-btn 
                            color="warning" 
                            justify-center 
                            v-if="loading_results"
                            style="pointer-events: none"
                        >Loading</v-btn>
                        <v-btn 
                            @click="gatherData"
                            color="success"
                            justify-center
                            v-else
                        >Run</v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout align-center justify-center row>
            <v-flex xs12 sm10 md6 lg4>
                <v-alert
                    :value="testAlerts || entitiesLoadError"
                    :dismissible="true"
                    v-if="!loading_results"
                    type="warning"
                >
                    Sorry, there was a problem loading options
                </v-alert>
                <v-alert
                    :value="testAlerts || responseError"
                    :dismissible="true"
                    v-if="!loading_results"
                    type="warning"
                >
                    Sorry, there was a problem loading data
                </v-alert>
                <v-alert
                    :value="testAlerts || responseDataEmpty"
                    :dismissible="true"
                    v-if="!loading_results"
                    type="info"
                >
                    No data available
                </v-alert>
            </v-flex>
        </v-layout>
        <br>
        <v-layout align-center justify-center>
            <v-flex xs12 sm12 md12 lg10 xl10 class="vld-parent">
                <loading 
                    :active.sync="loading_results" 
                    :can-cancel="false" 
                    :is-full-page="false"
                    loader="dots"
                    color="#4caf50"
                    :height="120"
                    :width="120"
                    v-if="this.data_records.length"
                    :opacity="0.7"
                ></loading>
                <AdminDataTable 
                    :rows="this.data_records"
                    v-if="this.data_records.length"
                    :dateFrom="this.date_from"
                    :dateTo="this.date_to"
                    :groupByMonth="this.group_by_month"
                />
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import AdminDataTable from './AdminDataTable'
import { mapGetters } from 'vuex'

export default {
    components: {
        AdminDataTable,
        Loading,
    },
    data() {
        return {
            // values and flags for "Select all" buttons
            all_platforms_selected: false,
            select_all_platforms_label: 'Select all',

            all_advertisers_selected: false,
            select_all_advertisers_label: 'Select all',

            all_campaigns_selected: false,
            select_all_campaigns_label: 'Select all',

            all_os_selected: false,
            select_all_os_label: 'Select all',

            // values to show/hide datepickers
            date_from_menu: false,
            date_to_menu: false,

            // values to toggle "Group by" inputs
            group_by_day: false,
            group_by_month: false,
            group_by_platform: false,
            group_by_advertiser: false,
            group_by_campaign: false,
            group_by_country: false,
            group_by_os: false,

            // loading flag
            loading_results: false,

            // dates for datepickers
            date_from: new Date(new Date().setDate(new Date().getDate()-1)).toISOString().substr(0, 10),
            date_to: new Date(new Date().setDate(new Date().getDate()-1)).toISOString().substr(0, 10),
            date_today: new Date().toISOString().substr(0, 10),

            // data table records
            data_records: [],

            os_choices: [
                { name: 'iOS', os_id: 11},
                {name: 'Android', os_id: 10},
                {name: 'Other', os_id: 12},
            ],

            // arrays with selected entities
            selected_platforms:[],
            selected_advertisers:[],
            selected_campaigns:[],
            selected_os:[],

            responseDataEmpty: false,
            responseError: false,
            
            // show alerts for testing
            testAlerts: false,
        }
    },
    computed: {
        ...mapGetters([
            'getPlatforms',
            'getAdvertisers',
            'getCampaigns',
            'gotEntities'
            ]),
        entitiesLoadError() {
            return !this.getPlatforms.length || !this.getAdvertisers.length || !this.getCampaigns.length
        }
    },
    methods: {
        selectAllPlatforms() {
            this.$nextTick(() => {
                if (this.all_platforms_selected) {
                    this.selected_platforms = []
                    this.all_platforms_selected = false
                    this.select_all_platforms_label = 'Select all'
                } else {
                    this.selected_platforms = this.getPlatforms.map(platform => platform.external_id)
                    this.all_platforms_selected = true
                    this.select_all_platforms_label = 'Unselect all'
                }
            })
        },
        selectAllAdvertisers() {
            this.$nextTick(() => {
                if (this.all_advertisers_selected) {
                    this.selected_advertisers = []
                    this.all_advertisers_selected = false
                    this.select_all_advertisers_label = 'Select all'
                } else {
                    this.selected_advertisers = this.getAdvertisers.map(advertiser => advertiser.external_id)
                    this.all_advertisers_selected = true
                    this.select_all_advertisers_label = 'Unselect all'
                }
            })
        },
        selectAllCampaigns() {
            this.$nextTick(() => {
                if (this.all_campaigns_selected) {
                    this.selected_campaigns = []
                    this.all_campaigns_selected = false
                    this.select_all_campaigns_label = 'Select all'
                } else {
                    this.selected_campaigns = this.getCampaigns.map(campaign => campaign.external_id)
                    this.all_campaigns_selected = true
                    this.select_all_campaigns_label = 'Unselect all'
                }
            })
        },
        selectAllOS() {
            this.$nextTick(() => {
                if (this.all_os_selected) {
                    this.selected_os = []
                    this.all_os_selected = false
                    this.select_all_os_label = 'Select all'
                } else {
                    this.selected_os = this.os_choices.map(os_obj => os_obj.os_id)
                    this.all_os_selected = true
                    this.select_all_os_label = 'Unselect all'
                }
            })
        },
        gatherData() {
            this.loading_results = true
            this.responseDataEmpty = false
            this.responseError = false

            // compose query parameters
            let params = {
                from: this.date_from,
                to: this.date_to
            }
            let agg_list = []
            if (this.group_by_day) {
                agg_list.push('date')
            }
            if (this.group_by_month) {
                agg_list.push('month(date(date))')
            }
            if (this.group_by_platform) {
                agg_list.push('platform_id')
            }
            if (this.group_by_advertiser) {
                agg_list.push('advertiser_id')
            }
            if (this.group_by_campaign) {
                agg_list.push('campaign_id')
            }
            if (this.group_by_os) {
                agg_list.push('os_id')
            }
            if (agg_list != []) {
                params.agg = agg_list.join(',')
            }

            if (this.selected_platforms.length > 0) {
                params.platform_id = this.selected_platforms.join(',')
            }
            if (this.selected_advertisers.length > 0) {
                params.advertiser_id = this.selected_advertisers.join(',')
            }
            if (this.selected_campaigns.length > 0) {
                params.campaign_id = this.selected_campaigns.join(',')
            }
            if (this.selected_os.length > 0) {
                params.os_id = this.selected_os.join(',')
            }
           
            console.log(JSON.stringify(params, null, "    "))

            axios.get('report/', {
                params:params
            })
            .then(resp =>{
                this.data_records = resp.data
                if (!this.data_records.length) {
                    this.responseDataEmpty = true
                }
            })
            .catch(err =>{
                console.log(err)
                this.responseError = true
                this.data_records = []
            })
            .then(() => {
                this.loading_results = false})

        },
        resolveDateGroupBys(){
            if (this.group_by_day) {
                this.group_by_month = false
            }
        }
    },
    watch: {
        group_by_day(){
            if (this.group_by_day) {
                this.group_by_month = false
            }
        },
        group_by_month(){
            if (this.group_by_month){
                this.group_by_day = false
            }
        }
    },
    created() {
        if (!this.gotEntities) {
            this.$store.dispatch('fetchEntities')
        }
    }
}
</script>

<style>
.v-switch {
  align-items: center;
  justify-content: center;
}
.rounded-block {
    border-radius: 20px;
}
</style>
